import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class Schedules extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "Schedules";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {
      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {

    if (data.recurring) {
      data.recurring = new models.api.Recurring(data.recurring);
    }

    if (data.customer) {
      data.customer = new models.api.Customers(data.customer);
    }

    if (data.order) {
      data.order = new models.api.Orders(data.order);
    }

    if (data.settings) {
      data.settings = new models.api.ScheduleSettings(data.settings);
    }

    if (data.mid) {
      data.mid = new models.api.Mids(data.mid);
    }

    if (data.transactions && data.transactions.length > 0) {
      data.transactions.map(async (transaction) => {
        transaction = new models.api.Transactions(transaction);
      });
    }


    // use this for transforming your data, e.g. transform a Date-string into a Date object; see: https://vuex.feathersjs.com/model-classes.html#setupinstance
    return data;
  }
}
